import { none, State } from "@hookstate/core";
import { Validation } from "@hookstate/validation";
import { isNullOrEmpty } from "../utils/Arrays";
import { ServiceKeys } from "./ConfigDataState";
import { Coupons, EMPTY_COUPON, EMPTY_EVENTDATE, EMPTY_LINK, EMPTY_MEDIA, EMPTY_NEWS, EMPTY_PERSON, EMPTY_PRODUCT, EMPTY_SHOWROOM, EMPTY_TRADEMARK, EMPTY_JOB, EventDate, ExhibitorData, Link, Media, News, Person, Product, Showrooms, Trademark, Job, PrintCatalog, countryHasZipCode } from "./ExhibitorDataState";
import branding from "../branding/branding"
//const PHONE_REGEX = new RegExp('^[\\d+-// ]*$')
import moment from 'moment';
import { compareDates, date1GreaterThanOrEqualDate2, now } from '../utils/Dates';
import { hasServiceKeys } from '../globalStates/ConfigDataState';

const EMAIL_REGEX = new RegExp("^[A-Za-z0-9](.*)([@]{1})(.{1,})(\\.)(.{1,})")

const URL_REGEX = new RegExp('^((ft|htt)ps?:\\/\\/)?' + // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name and extension
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
    '(\\:\\d+)?' + // port
    '(\\/[-a-z\\d%@_.~+&:]*)*' + // path
    '(\\?[;&a-z\\d%@_.,~+&:=-]*)?' + // query string
    '(\\#[-a-z\\d_]*)?$', 'i')

// const DATETIME_REGEX = new RegExp("(19|20)[0-9]{2}-(0|1)[0-9]-[0-3][0-9] 0[0-9]|1[0-9]|2[0123]:[012345][0-9]:[012345][0-9]")

const isNotMonoLingual = !branding.configuration.monoLingual

function fixEmpty<T>(stateArray: State<T[]>, addValidation: (state: State<T[]>) => void, emptyElement: T) {
    const isEmpty = isNullOrEmpty(stateArray.get())
    if (isEmpty) {
        stateArray.merge([emptyElement])
    }
    addValidation(stateArray)
    if (isEmpty) {
        setTimeout(() => {
            stateArray[0].set(none)
        }, 0);
    }
}

export function addValidators(exhibitorDatastate: State<ExhibitorData>, serviceKeys: ServiceKeys) {

    Validation(exhibitorDatastate.organization.postCode).validate((postCode: string) => !countryHasZipCode(exhibitorDatastate.organization.countryCode.get()) || (!!postCode && postCode.length > 0), 'missingCompanyPostcode')
    Validation(exhibitorDatastate.organization.city).validate((city: string) => !!city && city.length > 0, 'missingCompanyCity')
    Validation(exhibitorDatastate.organization.countryCode).validate((countryCode: string) => !!countryCode && countryCode.length > 0, 'missingCompanyCountry')

    if (branding.configuration.profilePage.sctBasicInfoMandatory.companyNameMandatory) {
        Validation(exhibitorDatastate.organization.name).validate((name: string) => !!name && name.length > 0, 'missingCompanyName')
    }
    if (branding.configuration.profilePage.sctBasicInfoMandatory.phoneNumberMandatory) {
        Validation(exhibitorDatastate.organization.phone).validate((phone: string) => !!phone && phone.length > 0, 'missingCompanyPhone')
    }
    if (branding.configuration.profilePage.sctBasicInfoMandatory.mobileNumberMandatory) {
        Validation(exhibitorDatastate.organization.mobile).validate((mobile: string) => !!mobile && mobile.length > 0, 'missingCompanyMobile')
    }
    if (branding.configuration.profilePage.sctBasicInfoMandatory.faxMandatory) {
        Validation(exhibitorDatastate.organization.fax).validate((fax: string) => !!fax && fax.length > 0, 'missingCompanyFax')
    }
    if (branding.configuration.profilePage.sctBasicInfoMandatory.emailMandatory) {
        Validation(exhibitorDatastate.organization.email).validate((email: string) => !!email && email.length > 0, 'missingCompanyEmail')
    }
    if (branding.configuration.profilePage.sctBasicInfoMandatory.websiteMandatory) {
        Validation(exhibitorDatastate.organization.web).validate((web: string) => !!web && web.length > 0, 'missingCompanyWebsite')
    }
    if (branding.configuration.profilePage.sctBasicInfoMandatory.address1Mandatory) {
        Validation(exhibitorDatastate.organization.address1).validate((address1: string) => !!address1 && address1.length > 0, 'missingCompanyAddress')
    }
    if (branding.configuration.profilePage.sctBasicInfoMandatory.address2Mandatory) {
        Validation(exhibitorDatastate.organization.address2).validate((address2: string) => !!address2 && address2.length > 0, 'missingCompanyAddress')
    }
    if (branding.configuration.profilePage.sctBasicInfoMandatory.address3Mandatory) {
        Validation(exhibitorDatastate.organization.address3).validate((address3: string) => !!address3 && address3.length > 0, 'missingCompanyAddress')
    }
    if (branding.configuration.profilePage.sctBasicInfoMandatory.zipCodeMandatory) {
        Validation(exhibitorDatastate.organization.postCode).validate((postCode: string) => !!postCode && postCode.length > 0, 'missingCompanyPostcode')
    }
    if (branding.configuration.profilePage.sctBasicInfoMandatory.cityMandatory) {
        Validation(exhibitorDatastate.organization.city).validate((city: string) => !!city && city.length > 0, 'missingCompanyCity')
    }
    if (branding.configuration.profilePage.sctBasicInfoMandatory.countryMandatory) {
        Validation(exhibitorDatastate.organization.countryCode).validate((countryCode: string) => !!countryCode && countryCode.length > 0, 'missingCompanyCountry')
    }
    if (branding.configuration.profilePage.sctBasicInfoMandatory.companySizeMandatory) {
        Validation(exhibitorDatastate.organization.size).validate((size: string) => !!size && size.length > 0, 'missingCompanySize')
    }
    if (branding.configuration.profilePage.sctBasicInfoMandatory.industryMandatory) {
        Validation(exhibitorDatastate.organization.industry).validate((industry: string) => !!industry && industry.length > 0, 'missingCompanyIndustry')
    }
    if (branding.configuration.profilePage.sctBasicInfoMandatory.foundingYearMandatory) {
        Validation(exhibitorDatastate.organization.foundingYear).validate((foundingYear: string) => !!foundingYear && foundingYear.length > 0, 'missingCompanyFoundingYear')
    }

    //Validation(exhibitorDatastate.organization.mobile).validate((mobile: string | undefined) => !mobile || PHONE_REGEX.test(mobile), 'Please enter a valid mobile number')
    //Validation(exhibitorDatastate.organization.phone).validate((phone: string | undefined) => !phone || PHONE_REGEX.test(phone), 'Please enter a valid phone number')
    //Validation(exhibitorDatastate.organization.fax).validate((fax: string | undefined) => !fax || PHONE_REGEX.test(fax), 'Please enter a valid fax number')
    Validation(exhibitorDatastate.organization.email).validate((email: string | undefined) => !email || EMAIL_REGEX.test(email), 'invalidCompanyEmail')
    Validation(exhibitorDatastate.organization.email2).validate((email2: string | undefined) => !email2 || EMAIL_REGEX.test(email2), 'invalidCompanyEmail2')
    if (hasServiceKeys(serviceKeys.link)) {
        fixEmpty(exhibitorDatastate.organization.links, addValidatorsLinks, EMPTY_LINK)
    }
    if (hasServiceKeys(serviceKeys.products)) {
        fixEmpty(exhibitorDatastate.organization.products, addValidatorsProducts, EMPTY_PRODUCT)
    }
    if (hasServiceKeys(serviceKeys.trademarks)) {
        fixEmpty(exhibitorDatastate.organization.trademarks, addValidatorsTrademarks, EMPTY_TRADEMARK)
    }
    if (hasServiceKeys(serviceKeys.contactPartner)) {
        fixEmpty(exhibitorDatastate.organization.persons, addValidatorsTeams, EMPTY_PERSON)
    }
    if (hasServiceKeys(serviceKeys.multimedia)) {
        fixEmpty(exhibitorDatastate.organization.medias, addValidatorsMultimedia, EMPTY_MEDIA)
    }
    if (hasServiceKeys(serviceKeys.news)) {
        fixEmpty(exhibitorDatastate.organization.newsList, addValidatorsNews, EMPTY_NEWS)
    }

    const eventDatesVisible = (hasServiceKeys(serviceKeys.eventDate)
        || hasServiceKeys(serviceKeys.eventDateMasterClass)
        || hasServiceKeys(serviceKeys.eventDateRemoteLiveStream)
        || hasServiceKeys(serviceKeys.eventDatePreRecorded)
        || hasServiceKeys(serviceKeys.eventDateRoundTable)
    )

    if (eventDatesVisible) {
        fixEmpty(exhibitorDatastate.organization.eventDates, addValidatorsEventDates, EMPTY_EVENTDATE)
    }
    if ((serviceKeys.showroomPublic !== undefined && hasServiceKeys(serviceKeys.showroomPublic)) || (serviceKeys.showroomPrivate !== undefined && hasServiceKeys(serviceKeys.showroomPrivate))) {
        fixEmpty(exhibitorDatastate.organization.showrooms, addValidatorsShowrooms, EMPTY_SHOWROOM)
    }

    const hasServiceKeyGoodies = hasServiceKeys(serviceKeys.goodies)
    if (hasServiceKeyGoodies) {
        fixEmpty(exhibitorDatastate.organization.goodies, addValidatorsCoupons, EMPTY_COUPON)
    }
    const hasServiceKeyJobAd = hasServiceKeys(serviceKeys.jobAd)
    if (hasServiceKeyJobAd) {
        fixEmpty(exhibitorDatastate.organization.jobOffers, addValidatorsJobs, EMPTY_JOB)
    }
    const printVisible =
        hasServiceKeys(serviceKeys.printOrganizationName)
        || hasServiceKeys(serviceKeys.printAddress)
        || hasServiceKeys(serviceKeys.printContact)
        || hasServiceKeys(serviceKeys.printLogo)
        || hasServiceKeys(serviceKeys.printLogoExhibitorDirectory)
        || hasServiceKeys(serviceKeys.printLogoCategoryDirectory)
        || hasServiceKeys(serviceKeys.printDescription)
        || hasServiceKeys(serviceKeys.printAd)

    const deadline = branding.configuration.printPage.deadLine && moment(branding.configuration.printPage.deadLine).toDate()
    const printCatalogReadOnly = !!(deadline && (compareDates(deadline, now()) < 0))

    if (printVisible && !printCatalogReadOnly) {
        addValidatorsPrintCatalog(exhibitorDatastate.organization.printCatalog, serviceKeys)
    }
}

export function addValidatorsLinks(links: State<Link[]>) {
    links.forEach(link => {
        isNotMonoLingual && Validation(link.text).validate((text: string) => !!text && text.length > 0, 'missingLinkName')
        Validation(link.textDe).validate((text: string) => !!text && text.length > 0, 'missingLinkName')
        isNotMonoLingual && Validation(link.url).validate((url: string) => !!url && url.length > 0, 'missingLinkUrl')
        Validation(link.urlDe).validate((url: string) => !!url && url.length > 0, 'missingLinkUrl')
    })
}

export function addValidatorsProducts(products: State<Product[]>) {
    products.forEach(product => {
        isNotMonoLingual && Validation(product.name).validate((name: string) => !!name && name.length > 0, 'missingProductName')
        Validation(product.nameDe).validate((name: string) => !!name && name.length > 0, 'missingProductName')
        // product.showFrom.get() && product.showUntil.get() && Validation(product.showUntil).validate(() => compareDates(product.showFrom.get(), product.showUntil.get()) > -1, 'invalidProductPublicationEndDate')
        Validation(product.showFrom).validate((date: Date | undefined | number) => date1GreaterThanOrEqualDate2(date, now()) > -1, 'dateGreaterThanOrEqual')
        Validation(product.showUntil).validate((date: Date | undefined) => compareDates(date, now()) > -1, 'dateGreaterThanCurrentDate')
        Validation(product.crossValidation).validate(() => compareDates(product.showUntil.get(), product.showFrom.get()) > -1, 'invalidProductPublicationEndDate')
        Validation(product)
            .validate((date: any) => {
                const date1GraterThanDate2 = compareDates(date.showUntil, product.showFrom.get()) > -1
                return date1GraterThanDate2
            }
                , 'invalidProductPublicationEndDate'
            )
        fixEmpty(product.medias, addValidatorsMultimedia, EMPTY_MEDIA)
    })
}

export function addValidatorsTrademarks(trademarks: State<Trademark[]>) {
    trademarks.forEach(trademark => {
        Validation(trademark.name).validate((name: string) => !!name && name.length > 0, 'missingTrademarkName')
        fixEmpty(trademark.medias, addValidatorsMultimedia, EMPTY_MEDIA)
    })
}

export function addValidatorsTeams(persons: State<Person[]>) {
    persons.forEach(person => {
        Validation(person.firstName).validate((firstName: string) => !!firstName && firstName.length > 0, 'missingFirstName')
        Validation(person.lastName).validate((lastName: string) => !!lastName && lastName.length > 0, 'missingLastName')
        Validation(person.email).validate((email: string) => !!email && email.length > 0, 'missingEmail')
        Validation(person.email).validate((email: string) => !email || EMAIL_REGEX.test(email), 'invalidEmail')
        Validation(person.function).validate((role: string) => !!role && role.length > 0, 'missingRole')
    })
}

export function addValidatorsMultimedia(medias: State<Media[]>) {
    medias.forEach(media => {
        isNotMonoLingual && Validation(media.title).validate((title: string) => !!title && title.length > 0, 'missingMediaTitle')
        Validation(media.titleDe).validate((title: string) => !!title && title.length > 0, 'missingMediaTitle')
    })
}

export function addValidatorsNews(newsList: State<News[]>) {
    newsList.forEach(news => {
        isNotMonoLingual && Validation(news.name).validate((name: string) => {
            return !!name && name.length > 0
        }, 'missingNewsTitle')
        Validation(news.nameDe).validate((name: string) => !!name && name.length > 0, 'missingNewsTitle')
        Validation(news.date).validate((date: Date | undefined) => !!date, 'missingNewsDate')
        fixEmpty(news.medias, addValidatorsMultimedia, EMPTY_MEDIA)
    })
}

export function addValidatorsEventDates(eventDates: State<EventDate[]>) {
    eventDates.forEach(eventDate => {
        isNotMonoLingual && Validation(eventDate.name).validate((name: string) => !!name && name.length > 0, 'missingEventDateTitle')
        Validation(eventDate.nameDe).validate((name: string) => !!name && name.length > 0, 'missingEventDateTitle')
        fixEmpty(eventDate.persons, addValidatorsTeams, EMPTY_PERSON)
        fixEmpty(eventDate.medias, addValidatorsMultimedia, EMPTY_MEDIA)
    })
}

export function addValidatorsShowrooms(showrooms: State<Showrooms[]>) {
    showrooms.forEach(showroom => {
        isNotMonoLingual && Validation(showroom.title).validate((title: string) => !!title && title.length > 0, 'missingShowroomTitle')
        Validation(showroom.titleDe).validate((title: string) => !!title && title.length > 0, 'missingShowroomTitle')
    })
}

export function addValidatorsCoupons(coupons: State<Coupons[]>) {
    coupons.forEach(coupon => {
        Validation(coupon.name).validate((name: string) => !!name && name.length > 0, 'missingCouponName')
        Validation(coupon.validStart).validate((date: Date | undefined) => !!date, 'missingValidStartDate')
        Validation(coupon.validEnd).validate((date: Date | undefined) => !!date, 'missingValidEndDate')
        Validation(coupon.url).validate((url: string) => !url || URL_REGEX.test(url), 'missingCouponValidUrl')
        Validation(coupon.urlDe).validate((urlDe: string) => !urlDe || URL_REGEX.test(urlDe), 'missingCouponValidUrl')
    })
}

export function addValidatorsJobs(jobs: State<Job[]>) {
    jobs.forEach(job => {
        isNotMonoLingual && Validation(job.title).validate((title: string) => !!title && title.length > 0, 'missingJobTitle')
        Validation(job.titleDe).validate((titleDe: string) => !!titleDe && titleDe.length > 0, 'missingJobTitle')
        Validation(job.startdate).validate((date: Date | undefined) => !!date, 'missingJobValidStartDate')
        Validation(job.showFrom).validate((date: Date | undefined) => !!date, 'missingJobValidStartDisplaying')
        fixEmpty(job.persons, addValidatorsTeams, EMPTY_PERSON)
        fixEmpty(job.medias, addValidatorsMultimedia, EMPTY_MEDIA)
    })
}

export function addValidatorsPrintCatalog(printCatalog: State<PrintCatalog>, serviceKeys: ServiceKeys) {
    if (hasServiceKeys(serviceKeys.printOrganizationName)) {
        Validation(printCatalog.name).validate((companyName: string) => !!companyName && companyName.length > 0, 'missingPrintCompanyName')
    }
    if (hasServiceKeys(serviceKeys.printAddress) || hasServiceKeys(serviceKeys.printAddressCategoryDirectory)) {
        Validation(printCatalog.address1).validate((address: string) => !!address && address.length > 0, 'missingPrintAddress')
        Validation(printCatalog.postcode).validate((postcode: string) => !countryHasZipCode(printCatalog.countryCode.get()) || (!!postcode && postcode.length > 0), 'missingPrintZipcode')
        Validation(printCatalog.city).validate((city: string) => !!city && city.length > 0, 'missingPrintCity')
        Validation(printCatalog.countryCode).validate((country: string) => !!country && country.length > 0, 'missingPrintCountry')
    }
    if (hasServiceKeys(serviceKeys.printContact) || hasServiceKeys(serviceKeys.printContactCategoryDirectory)) {
        Validation(printCatalog.email).validate((email: string | undefined) => !email || EMAIL_REGEX.test(email), 'invalidEmail')
    }
}